/* Over ons: scroll-verhaal, draaiende kaarten, kwaliteitscheck. Alles uit bij verminderde beweging waar het beweegt. */
(function () {
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (typeof customElements === 'undefined') return;

  if (!customElements.get('story-scroll')) {
    customElements.define('story-scroll', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.chapters = Array.from(this.querySelectorAll('.story__chapter'));
        this.animals = Array.from(this.querySelectorAll('.story__animal'));
        this.dots = Array.from(this.querySelectorAll('.story__dot'));
        this.num = this.querySelector('[data-story-num]');
        this.orb = this.querySelector('.story__orb');
        function set(i) {
          self.chapters.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
          self.animals.forEach(function (a, n) { a.classList.toggle('is-active', n === i); });
          self.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          if (self.num) self.num.textContent = '0' + (i + 1);
          if (self.orb) { self.orb.classList.remove('is-pop'); void self.orb.offsetWidth; self.orb.classList.add('is-pop'); }
        }
        var current = 0;
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                var i = self.chapters.indexOf(e.target);
                if (i > -1 && i !== current) { current = i; set(i); }
              }
            });
          }, { rootMargin: '-45% 0px -45% 0px' });
          this.chapters.forEach(function (c) { io.observe(c); });
        }
        this.dots.forEach(function (d, i) {
          d.addEventListener('click', function () { self.chapters[i].scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' }); });
        });
        this.chapters.forEach(function (c, i) {
          c.addEventListener('click', function () { current = i; set(i); });
        });
      }
    });
  }

  if (!customElements.get('pledge-cards')) {
    customElements.define('pledge-cards', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.pledge__card').forEach(function (card) {
          card.addEventListener('click', function () {
            card.setAttribute('aria-pressed', card.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          });
        });
      }
    });
  }

  if (!customElements.get('quality-check')) {
    customElements.define('quality-check', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var total = parseInt(this.getAttribute('data-total'), 10) || 0;
        var items = Array.from(this.querySelectorAll('.qcheck__item'));
        var n = this.querySelector('[data-qc-n]');
        var done = this.querySelector('[data-qc-done]');
        function update() {
          var c = items.filter(function (i) { return i.getAttribute('aria-pressed') === 'true'; }).length;
          if (n) n.textContent = c;
          var all = total > 0 && c === total;
          self.classList.toggle('is-done', all);
          if (done) done.hidden = !all;
        }
        items.forEach(function (it) {
          it.addEventListener('click', function () {
            it.setAttribute('aria-pressed', it.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
            update();
          });
        });
      }
    });
  }
})();
